class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    // Remember the real trigger unless a programmatic opener (the mobile
    // bottom-nav tab) already handed itself over via `openedBy`: on mobile
    // the in-header summary is display:none, so it can never take focus
    // back — the element that was focused before the trap can.
    this.openedBy =
      this.openedBy || (document.activeElement !== document.body ? document.activeElement : null);
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    // Drop [open] BEFORE restoring focus: the bottom nav (the opener's
    // home) is display:none while the sheet is open, and a hidden element
    // silently refuses focus — the old order stranded focus on <body>.
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    const opener = this.openedBy;
    this.openedBy = null;
    let restoreTo = null;
    if (focusToggle) {
      // getClientRects, not offsetParent: the bottom nav is position:fixed
      if (opener && document.contains(opener) && opener.getClientRects().length) {
        restoreTo = opener;
      } else if (this.summaryToggle.getClientRects().length) {
        restoreTo = this.summaryToggle;
      }
    }
    removeTrapFocus(restoreTo);
  }
}

customElements.define('details-modal', DetailsModal);
